import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { useT } from "@/i18n";

export default function NotFound() {
  const t = useT();
  usePageMeta(t("nf.meta"));
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="font-display text-6xl text-primary">404</p>
      <h1 className="font-display text-2xl text-foreground">{t("nf.title")}</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        {t("nf.body")}
      </p>
      <div className="mt-2 flex gap-3">
        <Button className="rounded-full" asChild><Link to="/">{t("nf.home")}</Link></Button>
        <Button variant="outline" className="rounded-full" asChild><Link to="/marketplace">{t("nav.marketplace")}</Link></Button>
      </div>
    </div>
  );
}
